import React from 'react';
import { useHistory } from 'react-router-dom';

import * as func from '../../../utils/funcs';
import { removeFromTeam } from '../../../api/removeFromTeam';
import { getGroupsList } from '../../../api/getGroupsList';
import PrimaryButton from './../../../partials/PrimaryButton';

import styles from './PlayerActionButtons.module.css';
import editIcon from './../../../graphics/icons/edit.svg';
import { getUserPlayerInfo } from '../../../api/getUserPlayerInfo';

function PlayerActionButtons(props) {
  const { user, setUser, player, leagueId, setTeams, refreshStates } = props;
  const history = useHistory();

  const [removeText, setRemoveText] = React.useState("יציאה מהקבוצה");

  React.useEffect(() => {
    let mounted = true;

    if (func.validGroupMasters(user, player.team) && mounted) {
      setRemoveText("הסרה מהקבוצה");
    }
    return function cleanup() {
      mounted = false;
    };
  }, [user, player]);

  const handleClickEdit = () => {
    history.push(`/leagues/${leagueId}/profile/edit`);
  };

  const handleClickRemove = async () => {
    const team_pk = player.team;
    await removeFromTeam(leagueId, team_pk, player.user.id);
    setUser(await getUserPlayerInfo());
    const res = await getGroupsList(leagueId);
    setTeams(res);
    history.push(`/leagues/${leagueId}/teams/${team_pk}`);
  };

  return (
    <div className={styles.coloumnBtns}>
      {player !== null && func.validToEditPlayer(user, player.user_id) ? (
        <span className={styles.editPlayer}>
          <img src={editIcon} alt="עריכת שחקן" onClick={handleClickEdit} />
        </span>
      ) : (
        <span> </span>
      )}

      <div className={styles.btnsBottom}>
        {player.team !== null && (
          <PrimaryButton
            text={removeText}
            onClick={handleClickRemove}
            size="medium"
            className={styles.removePlayer}
          />
        )}

        {player !== null && func.validUserIsPlayer(user, player.user_id) && (
          <PrimaryButton
            text="התנתקות"
            onClick={refreshStates}
            size="medium"
          />
        )}
      </div>
    </div>
  );
}

export default PlayerActionButtons;
